import { css, cx } from 'linaria';
import { usePopover } from 'components/popover/popover';
import { SaveIcon } from 'components/icons/SaveIcon';
import { SaveFilledIcon } from 'components/icons/SaveFilledIcon';
import { SavePopover } from 'components/item-actions/save-to-pocket';
import { breakpointLargeHandset } from 'common/constants';
import { Button } from 'components/buttons/button';
import { useTranslation } from 'next-i18next';
const saveArticleStyles = "s6y9bk2";
export function SaveArticleTop({
  url,
  saveAction,
  saveStatus,
  isAuthenticated,
  trackSaveClick
}) {
  const {
    t
  } = useTranslation();
  return <div className={cx(saveArticleStyles, 'top', 'save-article')}>
      <SaveStoryButton trackSaveClick={trackSaveClick} isAuthenticated={isAuthenticated} saveStatus={saveStatus} id="save-story-top" saveAction={saveAction} url={url} onClick={saveAction} />
      <p> {t('item-action:save-article-top', 'Read when you’ve got time to spare.')}</p>
    </div>;
}
export function SaveArticleBottom({
  url,
  saveAction,
  saveStatus,
  isAuthenticated,
  trackSaveClick
}) {
  const {
    t
  } = useTranslation();
  return <div className={cx(saveArticleStyles, 'top', 'save-article')}>
      <SaveStoryButton trackSaveClick={trackSaveClick} isAuthenticated={isAuthenticated} saveStatus={saveStatus} id="save-story-bottom" saveAction={saveAction} url={url} onClick={saveAction} />
      <p>
        {t('item-action:save-article-bottom', 'How was it? Save stories you love and never lose them.')}
      </p>
    </div>;
}
function SaveStoryButton({
  url,
  isAuthenticated,
  saveStatus,
  saveAction,
  id,
  trackSaveClick
}) {
  const {
    t
  } = useTranslation();
  const saveCopy = {
    unsaved: t('item-action:save-unsaved', 'Save'),
    saving: t('item-action:save-saving', 'Save'),
    saved: t('item-action:save-saved', 'Saved')
  };
  const handleClick = event => {
    event.preventDefault();
    event.stopPropagation();
    saveAction(url, id);
    if (trackSaveClick) trackSaveClick(id); // Legacy method: Remove on analytics confirmation
  };

  // Popover Effect
  const {
    popTrigger,
    popBody,
    shown
  } = usePopover({
    placement: 'top-start',
    modifiers: [{
      name: 'offset',
      options: {
        offset: [0, 0]
      }
    }]
  });
  return <>
      <Button onClick={handleClick} ref={popTrigger} data-cy={id}>
        {saveStatus === 'saved' ? <SaveFilledIcon /> : <SaveIcon />}
        {saveCopy[saveStatus]}
      </Button>
      {!isAuthenticated && shown ? <SavePopover popoverRef={popBody} id={id} /> : null}
    </>;
}

require("./save-article.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./save-article.js");